// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShippingPolicy_policyContainer__zBr9C {
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem;
  line-height: 1.6;
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
  color: #333;
  background: #fff;
}

.ShippingPolicy_title__y9AfX {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #222;
  text-align: center;
}

.ShippingPolicy_subtitle__zassX {
  font-size: 1.1rem;
  margin-bottom: 2rem;
  text-align: center;
  color: #555;
}

.ShippingPolicy_section__T\\+m35 {
  margin-bottom: 2rem;
}

.ShippingPolicy_sectionTitle__cTtST {
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #111;
}

.ShippingPolicy_text__4\\+YnQ {
  font-size: 1rem;
  color: #444;
  margin-bottom: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/Component/ShippingPolicy.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,4EAA4E;EAC5E,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB","sourcesContent":[".policyContainer {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 2rem;\n  line-height: 1.6;\n  font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n  color: #333;\n  background: #fff;\n}\n\n.title {\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n  color: #222;\n  text-align: center;\n}\n\n.subtitle {\n  font-size: 1.1rem;\n  margin-bottom: 2rem;\n  text-align: center;\n  color: #555;\n}\n\n.section {\n  margin-bottom: 2rem;\n}\n\n.sectionTitle {\n  font-size: 1.3rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  color: #111;\n}\n\n.text {\n  font-size: 1rem;\n  color: #444;\n  margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"policyContainer": `ShippingPolicy_policyContainer__zBr9C`,
	"title": `ShippingPolicy_title__y9AfX`,
	"subtitle": `ShippingPolicy_subtitle__zassX`,
	"section": `ShippingPolicy_section__T+m35`,
	"sectionTitle": `ShippingPolicy_sectionTitle__cTtST`,
	"text": `ShippingPolicy_text__4+YnQ`
};
export default ___CSS_LOADER_EXPORT___;
